import * as React from "react";
const SvgSuperhuman = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 22",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.97 1.03a62 62 0 0 1 9.726-.01c2.88.226 5.171 2.526 5.4 5.426.259 3.259.26 6.53.01 9.79-.223 2.898-2.51 5.204-5.39 5.435a62 62 0 0 1-9.726.01c-2.879-.225-5.17-2.526-5.4-5.426a63 63 0 0 1-.01-9.79C.804 3.567 3.09 1.259 5.97 1.03m5.47 8.857a.663.663 0 0 0-1.143 0l-4.303 7.338c-.338.58.304 1.237.894.913l3.662-2.019a.66.66 0 0 1 .64 0l3.662 2.019h-.001c.59.324 1.23-.333.892-.913zm-.57-5.701c-1.166 0-2.11.948-2.11 2.118s.945 2.117 2.11 2.117 2.11-.948 2.11-2.117-.944-2.118-2.11-2.118"
}));
export default SvgSuperhuman;
//# sourceMappingURL=Superhuman.js.map